<template>
  <CCard>
    <CCardHeader class="d-flex justify-content-between">
      <h2 class="text-uppercase font-weight-bold mb-0">Enterprise Builds</h2>
      <CButton color="primary" @click="newBuild">Upload New Version</CButton>
    </CCardHeader>
    <CCardBody>
      <CDataTable :items="data" :fields="fields" :loading="loading" pagination class="mb-0">
        <template #is_current_version="data">
          <td>
            <span v-if="data.item.is_current_version === 1" class="badge badge-published">
              Published
            </span>
          </td>
        </template>
        <template #created_at="data">
          <td>
            {{ $formatDateTime(data.item.created_at) }}
          </td>
        </template>
        <template #published_date="data">
          <td>
            {{ $formatDateTime(data.item.published_date) }}
          </td>
        </template>
        <template #actions="data">
          <td class="text-right">
            <div class="button-group">
              <CButton
                v-if="data.item.is_current_version === 0"
                size="sm"
                color="danger"
                class="action-button"
                @click="deleteBuild(data.item.id)"
              >
                Delete
              </CButton>

              <CButton
                v-if="shouldShowPublishButton(data.item)"
                size="sm"
                color="success"
                class="action-button"
                @click="publishBuild(data.item.id)"
              >
                Publish
              </CButton>

              <CButton
                size="sm"
                color="primary"
                class="action-button"
                @click="downloadBuild(data.item.id)"
              >
                Download
              </CButton>
            </div>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
    <upload-build-modal ref="upload_modal" @saved="fetchData" />
  </CCard>
</template>

<script>
import UploadBuildModal from './UploadBuildModal.vue';

export default {
  name: 'EnterpriseBuilds',
  components: {
    UploadBuildModal,
  },
  data() {
    return {
      data: [],
      loading: true,
      fields: [
        { key: 'name', label: 'Name' },
        { key: 'version', label: 'Version' },
        { key: 'build', label: 'Build' },
        { key: 'package', label: 'Package' },
        { key: 'is_current_version', label: 'Published' },
        { key: 'created_at', label: 'Creation Date' },
        { key: 'published_date', label: 'Published Date' },
        { key: 'actions', label: 'Actions', class: 'text-right', sorter: false },
      ],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true;
        const response = await this.$http.get('/app-versions');
        this.data = response.data.data || response.data;
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        this.loading = false;
      }
    },
    newBuild() {
      console.log('Open upload modal');
      this.$refs.upload_modal.open();
    },
    async downloadBuild(buildId) {
      try {
        const response = await this.$http.get(`/app-versions/download/${buildId}`);
        const url = response.data?.url || response.data?.data?.url;
        if (url) {
          window.open(url, '_blank');
        } else {
          this.$toast.error('Download URL not found');
        }
      } catch (error) {
        this.$toast.error('Error downloading build');
      }
    },
    async deleteBuild(buildId) {
      if (confirm('Are you sure you want to delete this build?')) {
        try {
          await this.$http.delete(`/app-versions/${buildId}`);
          this.fetchData();
        } catch (error) {
          console.error('Error deleting build:', error);
        }
      }
    },
    async publishBuild(buildId) {
      try {
        await this.$http.post(`/app-versions/${buildId}/publish`);
        this.fetchData();
      } catch (error) {
        console.error('Error publishing build:', error);
      }
    },
    shouldShowPublishButton(buildItem) {
      const currentVersion = this.data.find((item) => item.is_current_version === 1);
      const isHigherVersion = currentVersion ? buildItem.build > currentVersion.build : true;
      return buildItem.is_current_version === 0 && isHigherVersion;
    },
  },
};
</script>

<style scoped>
.badge-published {
  background-color: grey;
  color: white;
  padding: 0.25em 0.5em;
  border-radius: 0.25em;
  font-size: 0.875em;
}

.button-group {
  display: flex;
  justify-content: flex-end;
}

.action-button {
  margin-left: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
